import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { get } from "lodash";
import { defaultDesingItems } from "utils/constants";
const { colors: c } = defaultDesingItems;

const StyledHeaderBox = styled(Box)`
  padding-top: 30px;
  position: relative;

  .main-header {
    background: #f8f8fb;
    border: 1px solid #e3e2ec;
    box-shadow: 0px 2px 4px rgba(108, 114, 146, 0.15);
    border-radius: 36px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    height: 96px;

    &.hasUrl {
      height: 114px;
      .main-header__content {
        height: 64px;
      }
      .main-header__domen {
        display: block;
      }
    }

    &__content {
      display: flex;
      align-items: center;
      height: 100%;
    }
    &__domen {
      padding: 5px;
      line-height: 24px;
      display: none;
      p {
        text-align: center;
        color: #9e9eaa;
        font-size: 12px;
        margin: 0;
        a {
          color: #493e8f;
        }
      }
    }
    &__items {
      height: 100%;
      width: calc(100% - 72px);
      display: flex;
      gap: 6px;
      padding-left: 42px;
    }

    &__item-all {
      width: 100%;
      display: none;
      flex-direction: column;
      gap: 8px;
      &__item {
        width: 100%;
        display: flex;
        align-items: center;
        background: #f4f3f8;
        border: 1px solid #e8e7f1;
        border-radius: 8px;
        gap: 15px;
        padding: 16px;
        height: 64px;
        cursor: pointer;

        &.button {
          background: ${(props) => get(props, "design.colors.primary", c.primary)};
          color: ${(props) => get(props, "design.colors.button", c.button)};
          margin-top: 7px;
          justify-content: center;
          font-weight: 600;
          font-size: 16px;
          &.disabled {
            opacity: 0.4;
            cursor: unset;
          }
        }

        &__value {
          color: #2d2d4b;
          font-size: 18px;
          font-weight: 600;
        }
      }
    }

    &__item {
      border: 1px solid #bdbde2;
      border-radius: 8px;
      height: 100%;
      padding: 13px 20px;
      display: flex;
      align-items: center;
      gap: 15px;
      width: calc(33% - 4px);
      cursor: pointer;
      p {
        margin: 0;
      }

      &__content {
        width: calc(100% - 45px);
      }
      &__name,
      &__title {
        overflow: hidden;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 100%;
      }

      &__name {
        font-size: 13px;
        line-height: 24px;
        color: #493e8f;
      }
      &__title {
        font-size: 16px;
        line-height: 24px;
        color: #2d2d4b;
      }
      .material-icons {
        height: 30px;
        width: auto;
      }
    }

    &__button {
      width: 64px;
      height: 64px;
      min-width: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-left: 8px !important;
      cursor: pointer;
      background: ${(props) => get(props, "design.colors.primary", c.primary)};
      &,
      & span {
        color: ${(props) => get(props, "design.colors.button", c.button)};
      }

      svg {
        font-size: 2.1em;
      }

      &.disabled {
        opacity: 0.4;
        cursor: unset;
      }
    }
  }

  .daterange-container {
    position: absolute;
    width: 100%;
    top: 100%;
    padding: 0 35px;
    z-index: 99;
  }

  .daterange-body {
    background: #ffffff;
    border-radius: 0px 0px 32px 32px;
    box-shadow: 0px 2px 4px rgba(108, 114, 146, 0.15);
    padding: 25px;

    &__line {
      font-weight: 600;
      font-size: 21px;
      line-height: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      letter-spacing: 0.02em;
      color: #2d2d4b;
      padding: 0 10px;

      button {
        background: ${(props) => get(props, "design.colors.primary", c.primary)};
        border-radius: 42px;
        height: 54px;
        cursor: pointer;
        text-transform: uppercase;
        color: #6f581d;
        border: none;
        outline: none;
        padding: 10px 28px;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }

  .nomers {
    position: absolute;
    width: 100%;
    top: 100%;
    z-index: 99;
    right: 120px;
    width: 416px;
    padding: 25px 30px;
    background: #ffffff;
    border-radius: 0px 0px 16px 16px;
    box-shadow: 0px 2px 4px rgba(108, 114, 146, 0.15);

    .nomer {
      padding-bottom: 15px;
      border-bottom: 1px solid #e7e6f0;

      &-title {
        font-weight: 700;
        font-size: 16px;
        color: #2d2d4b;
      }
      span {
        font-weight: 400;
        font-size: 14px;
        line-height: 130%;
        color: #493e8f;
      }
    }

    &__button-group {
      gap: 10px;
      display: flex;
      font-family: monospace;
      button {
        height: 32px;
        width: 32px;
        border: none;
        outline: none;
        background: white;
        font-size: 24px !important;
        cursor: pointer;
        border: 1px solid #493e8f;
        border-radius: 4px;

        :disabled {
          background: #dddbea;
          opacity: 0.7;
          border: none;
          color: white;
        }
      }
      div {
        flex: 1.2;
        color: #493e8f;
        font-size: 18px;
        display: grid;
        place-items: center;
        font-family: monospace !important;
      }
    }

    .close-add-person {
      display: none;
      background: ${(props) => get(props, "design.colors.primary", c.primary)};
      color: ${(props) => get(props, "design.colors.button", c.button)};
      font-weight: 600;
      text-align: center;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      line-height: 24px;
      height: 64px;
      border-radius: 8px;
    }
  }

  @media (max-width: 1320px) {
    .main-header__item__title {
      max-width: 100%;
    }
  }

  @media (max-width: 1200px) and (min-width: 960px) {
    /* .main-header {
      border-radius: 36px;
    } */
    .daterange-container {
      /* top: 95%; */
      padding: 0 24px;
    }
  }
  @media (max-width: 960px) {
    .location {
      display: none;
    }
    .main-header__item {
      width: calc(50% - 6px);
    }
    .daterange-body__line {
      flex-direction: column;
      justify-content: center;
      gap: 45px;
    }
  }
  @media (max-width: 720px) {
    padding-top: 20px;
    padding-bottom: 20px;
    .nomers {
      right: 15px;
      max-width: 90%;
      .close-add-person {
        cursor: pointer;
        text-transform: uppercase;
        display: flex !important;
      }
    }
    .daterange-container {
      padding: 0;
      top: 102px;
    }
    .nomers {
      top: 182px;
      right: 0;
      width: 100%;
      max-width: 100%;
    }
    .daterange-body {
      padding: 15px;
      &__line button {
        display: none;
      }
    }
    .main-header {
      border-radius: 0px 0px 8px 8px;
      padding: 16px;
      height: auto;
      background: #ffffff;

      &.hasUrl {
        padding-bottom: 0;
        height: auto !important;
        .main-header__content {
          height: auto !important;
        }
      }

      &__items {
        display: none;
      }
      &__item-all {
        padding-block: 0;
        display: flex;
      }
      &__button {
        display: none;
      }
    }
  }
  @media (max-width: 450px) {
    .daterange-body__line {
      gap: 25px;
    }
    .daterange-body {
      padding: 8px;
    }
    .main-header {
      padding: 10px;
      &__item {
        padding: 0 12px;
      }
    }
  }
  @media (max-width: 380px) {
    .main-header {
      padding: 10px;
    }
  }
`;

export default StyledHeaderBox;
